import { Set as CustomSet } from '~commonInfra/utils/Set';
import { Messages } from '~src/codegen/Localize';
import { openReactConfirmationDialog } from '~src/commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { AdminProfileUpdateActionNotification } from '~src/userManagement/services/notifications/AdminProfileUpdateActionNotification';
import { IUserInfo } from '~src/userManagement/users/models/IUserInfo';

import { AdminProfilesService } from './AdminProfilesService';

type RemoveUsersParams = {
  userLuids: string[];
  adminProfileLuid: string;
  userSet: CustomSet<IUserInfo>;
};

export async function showRemoveUsersFromAdminProfileDialog(
  profileName: string,
  adminProfileLuid: string,
  userLuids: string[],
  userSet: CustomSet<IUserInfo>
): Promise<any> {
  const users = userSet.toArray();
  const title = users.length === 1
    ? Messages.adminProfileUsersRemoveDialogTitleSingle({ PROFILE_NAME: profileName, USER_NAME: users[0].displayName })
    : Messages.adminProfileUsersRemoveDialogTitlePlural({ PROFILE_NAME: profileName, COUNT: String(users.length) });

  return openReactConfirmationDialog<RemoveUsersParams, any>({
    title,
    message: Messages.adminProfileUsersRemoveDialogMessage(),
    actionName: Messages.adminProfileUsersRemoveDialogAction(),
    isActionDelete: true,
    paramsForAction: { userLuids, adminProfileLuid, userSet },
    action: async ({ userLuids: luids, adminProfileLuid: profileLuid, userSet: set }) => {
      const result = await AdminProfilesService.removeUsersFromProfile(luids, profileLuid);
      AdminProfileUpdateActionNotification.instance.notify(result, set);
      return result;
    },
    dialogWidth: TabDialogWidth.width500px,
  }).result;
}

export const RemoveUsersFromAdminProfileDialogAction = {
  showRemoveUsersFromAdminProfileDialog,
};
